/* eslint-disable no-useless-escape */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-core-theme/src/hooks/link';
import Menu from 'gatsby-core-theme/src/components/molecules/menu';
import { toggleScroll } from 'gatsby-core-theme/src/helpers/scroll';
import NavigationProvider from 'gatsby-core-theme/src/components/organisms/navigation/navigationContext';
import styles from './navigation.module.scss';

const Navigation = ({ section, logo = '', languages = [], category = '', sports }) => {
  const options = {
    mobile: {
      animation: 'collapse',
      closeHandler: null,
      stopScrollOnOpen: false,
      canOpenAllSubMenus: false,
      subMenuDropDownButton: false,
    },
    desktop: {
      orientation: 'horizontal',
    },
  };

  const isMenuActive = (name) => name === category;

  const navRef = useRef(React.createRef());

  if (options.mobile.stopScrollOnOpen) toggleScroll('', true);

  const onClickHandler = () => {
    if (
      typeof window !== 'undefined' &&
      window.location.href.replace(window.location.origin, '') === '/'
    ) {
      window.location.reload();
    }
  };

  return (
    <div className={styles.header}>
      <div className={styles.languageBar}>
        <ul>
          {languages.map((item) => (
            <li key={item.url}>
              <a href={item.url} title={item.name} className="main-menu-gtm">
                <img alt={item.name} src={item.image} width={20} height={14} />
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className={`${styles.navbar} ${styles[category]} `}>
        <nav className={styles.nav}>
          <Link className={`${styles.logo} main-menu-gtm logo-cta`} to="/" onClick={onClickHandler}>
            <picture>
              <source srcSet={`../../../../../../images/${logo}.webp`} type="image/webp" />
              <img
                src={`../../../../../../images/${logo}.png`}
                alt="logo"
                height={71}
                width={313}
              />
            </picture>
          </Link>
          <ul className={styles.topMenu}>
            {sports?.length &&
              sports
                .filter((item) => item.path)
                .map((sport) => (
                  <li className={isMenuActive(sport.name) && styles.active} key={sport.id}>
                    <Link to={sport.path} className="main-menu-gtm">
                      {sport.path}
                    </Link>
                  </li>
                ))}
          </ul>
        </nav>
      </div>
      {category !== 'home' && (
        <div className={styles.subNavbar}>
          <nav className={styles.subNav} ref={navRef}>
            <NavigationProvider>
              <Menu
                section={section}
                menu={`${category}_menu`}
                options={options}
                gtmClass="main-menu-gtm menu-gtm"
              />
            </NavigationProvider>
          </nav>
        </div>
      )}
    </div>
  );
};

Navigation.propTypes = {
  section: PropTypes.shape({
    modules: PropTypes.arrayOf(
      PropTypes.shape({
        short_code: PropTypes.string,
        children: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            value: PropTypes.string,
          })
        ),
      })
    ),
  }).isRequired,
  logo: PropTypes.string,
  options: PropTypes.shape({
    mobile: PropTypes.shape({
      animation: PropTypes.string,
      closeHandler: PropTypes.func,
      stopScrollOnOpen: PropTypes.bool,
      canOpenAllSubMenus: PropTypes.bool,
      subMenuDropDownButton: PropTypes.bool,
    }),
    desktop: PropTypes.shape({
      orientation: PropTypes.string,
    }),
  }),
  languages: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, url: PropTypes.string })),
  category: PropTypes.string,
  sports: PropTypes.arrayOf(PropTypes.shape({})),
};

export default Navigation;
